import { render, staticRenderFns } from "./WebPartPageRow.vue?vue&type=template&id=4b06148e&scoped=true"
import script from "./WebPartPageRow.ts?vue&type=script&lang=ts&external"
export * from "./WebPartPageRow.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b06148e",
  null
  
)

export default component.exports